<div class="main">
    <div class="dialogue">
        <h1>Hey, You are back already? I thought you were going to take a while</h1>
        <h2>Yea.... I was not feeling well</h2>
        
    </div>
</div>